import { getDate, getMonth, getYear } from "date-fns";

export const middleOfDay = (date: Date): Date =>
  new Date(Date.UTC(getYear(date), getMonth(date), getDate(date), 12, 0, 0, 0));
